import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Purchase_Reopen, Purchase_Summary_Post } from "../../../Server/ApiV2";

export default function ClosePurchaseConfirm({
    onOpen,
    onClose,
    ratio = 0,
    header,
    UserCd,
    onLoad,
}) {

  const handleConfirmClose = async () => {
    try {
    const res = await Purchase_Summary_Post({
      TransId: header?.TransId,
      UserCd,
    });
    if (res?.status === 200) {
      onLoad();
      onClose();
    }
    } catch (err) {}
  };

  return (
    <>
      <Dialog open={onOpen} onClose={onClose}>
        <DialogTitle>Confirm Close</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are completed <strong>{ratio}</strong>.{" "}
            Do you want to close this purchase?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmClose}
            variant="contained"
            color="primary"
            autoFocus
          >
            Yes, Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
